import { Col, Divider, Modal, Row, Slider, Space, Tag, InputNumber, Button } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";


import { DatePicker, Input, RadioGroup, Select } from "components/form";
import styles from "../styles/NewFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const NewAndPolicyFilters = ({
  initialValues = {},

  employeeOptions = [],

  rolePermissionOptions = [],
  dataFlag = null,
  roleOption = [],

  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const flagPage = null;
  const { modifiedStatus = [] } = useStatusFlagOption()
  const statusOption = [
    {
      value: "",
      name: "All",
      label: t('approve-status.all')
    },
    {
      value: "Y",
      name: "Active",
      label: t('status.active')
    },
    {
      value: "N",
      name: "Inactive",
      label: t('status.inactive')
    }
  ]
  console.log("roleOptionroleOption", roleOption);
  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSearch({
          ...values,
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (

          <Form>
            {dataFlag == "new" && (
              <Row gutter={[0, 16]} className={styles.filter} >
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <Input
                    name="subject"
                    label={t('userList.label.newName')}
                    placeholder={t('userList.label.newName')}
                    size="large"
                  />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <Select
                    name="announcementBy"
                    label={t('userList.label.announceBy')}
                    placeholder={t("common.pleaseSelect")}
                    size="large"
                    options={employeeOptions}
                  />
                </Col>
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <Select
                    name="audienceGroupId"
                    label={t("news.label.audience_group")}
                    placeholder={t("common.pleaseSelect")}
                    size="large"
                    // mode="multiple"
                    options={rolePermissionOptions}
                  />
                </Col>

                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t("common.pleaseSelect")}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "policy" && (
              <Row gutter={[0, 16]} className={styles.filter} >
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <Input
                    name="category"
                    label={
                      t("policy.label.category") +
                      t("common.required_field_suffix")
                    }
                    placeholder={
                      t("policy.label.category")
                    }
                    size="large"
                  // options={modifiedPolicyCategory}
                  />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <Input
                    name="policyCode"
                    label={t('userList.label.policyCode')}
                    placeholder={t('userList.label.policyCode')}
                    size="large"
                  />
                </Col>
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <Input
                    name="policyName"
                    label={t('userList.label.policyname')}
                    placeholder={t('userList.label.policyname')}
                    size="large"
                  />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={statusOption}
                  />
                </Col>

              </Row>
            )}

            <Row justify="end">
              <Space size={12} className={styles.filter}>
                <Button type="default" onClick={resetForm} style={{ height: "40px" }}>
                  {t("common.cancel").toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ backgroundColor: "var(--button-color)", color: "#ffff", height: "40px" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>

          </Form>
        );
      }}
    </Formik>
  );
};

export default NewAndPolicyFilters;
